import { SiteFiltersStore, SiteFiltersStoreSchema, defaultValues, resetSiteFiltersStore } from "./store";
import { proxy, subscribe } from "valtio";

import { siteStore } from "src/js/stores/site/store";
import { subscribeKey } from "valtio/utils";

const LOCAL_STORAGE_KEY = "siteFiltersMapStore";

let previousWorkspaceId = siteStore.selectedWorkspaceId;

function loadFiltersFromLocalStorageSafely(): SiteFiltersStore {
  try {
    const persistedFilters = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)!);

    if (!persistedFilters) {
      return { ...defaultValues };
    }

    return SiteFiltersStoreSchema.parse(persistedFilters);
  } catch (error) {
    console.error("Error loading persisted filters:", error);
    return { ...defaultValues };
  }
}

export const siteFiltersMapStore = proxy<SiteFiltersStore>(loadFiltersFromLocalStorageSafely());

// when the store changes, persist the filters to local storage
subscribe(siteFiltersMapStore, function syncStoreToLocalStorage() {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(siteFiltersMapStore));
});

// when the selected workspace changes, reset the saved sites filters
subscribeKey(siteStore, "selectedWorkspaceId", (newWorkspaceId) => {
  if (previousWorkspaceId !== null && newWorkspaceId !== previousWorkspaceId) {
    resetSiteFiltersStore(siteFiltersMapStore);
  }
  previousWorkspaceId = newWorkspaceId;
});
